import Database from '../types/Database'

const EARTH_RADIUS_KM = 6371

export function haversineDistance(
  a: { lat: number; lng: number },
  b: { lat: number; lng: number }
): number {
  const toRad = (deg: number) => (deg * Math.PI) / 180
  const dLat = toRad(b.lat - a.lat)
  const dLng = toRad(b.lng - a.lng)
  const sinLat = Math.sin(dLat / 2)
  const sinLng = Math.sin(dLng / 2)
  const h =
    sinLat * sinLat +
    Math.cos(toRad(a.lat)) * Math.cos(toRad(b.lat)) * sinLng * sinLng
  return 2 * EARTH_RADIUS_KM * Math.asin(Math.sqrt(h))
}

export function filterByRadius(
  dives: Database.Dive[],
  center: { lat: number; lng: number },
  radiusKm: number
): (Database.Dive & { distanceKm: number })[] {
  return dives
    .map(dive => ({
      ...dive,
      distanceKm: haversineDistance(center, {
        lat: dive.location.latitude,
        lng: dive.location.longitude
      })
    }))
    .filter(d => d.distanceKm <= radiusKm)
}
